module.exports = __webpack_public_path__ + "img/9c0e7c9c-b633-4297-87db-8830d6e4b548.57167e87.jpg";